import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { DeferredPaymentSchedule } from '../../../../models/FlowOfFunds/deferred-payments.model';

export const GetDeferredPaymentSchedule = createAsyncThunk(
    'flowOfFunds/getDeferredPaymentSchedule',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/FlowOfFunds/${engagementId}/deferred-payments`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch the deferred payment schedule');
            }

            return response.data as DeferredPaymentSchedule;
        } catch (error) {
            createNotification(
                'There was an error while loading post-closing payments.',
                'error'
            );
            throw error;
        }
    }
);
